import { createContext } from 'react';

/**
 * Used to transport a reference to the current custom element into the wrapped component.
 */
const CustomElementContext = createContext<{ element?: HTMLElement; setAttr?: (k: string, v: string) => void }>({
  element: null,
  setAttr: null,
});

export default CustomElementContext;
